import styled from 'styled-components';
import { m } from 'framer-motion';

import LazyImage from '@glowforge/gf-styled/src/components/contentful-views/image';
import {
  getTypographyVariant,
} from '@glowforge/gf-styled/src/components/typography';

const PillButtonWrapper = styled('div')`
  padding: 0 20px 50px 20px;
  grid-column: full-start / full-end;
  display: flex;
  flex-direction: row;
  justify-content: center;
  white-space: nowrap; /* Don't wrap buttons. */
  padding-bottom: 34px;
  flex-wrap: wrap;
  column-gap: 15px;
  row-gap: 20px;
  @media (max-width: 991px){
    justify-content: flex-start;
    overflow-x: auto;
    flex-wrap: nowrap;
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

const PillButton = styled('button')`
  max-width: 100px;
  min-width: 100px;
  min-height: 34px !important;
  font-size: 16px !important;
  padding: 0;
  color: black !important;
  font-size: inherit;
  letter-spacing: -0.8px !important;
  line-height: 6.3px;
  flex: 1;
  border: 2px solid rgb(229, 229, 229,1);
  border-radius: 160px;
  background: ${(props) =>
    // no idea where this color came from or why it isn't in design system.
    props.active ? 'rgba(39,184,206,1)' : 'rgb(229, 229, 229,1)'};
  color: ${(props) =>
    props.active ? '#fff !important' : props.theme.colors.slate.base};
 
  transition: background 0.2s ease-in-out;
  ${getTypographyVariant('paragraph')}
  --font-family: 'Space Grotesk';
  --font-weight: 700;
  cursor: pointer;

  &:hover {
    background: ${(props) =>
    props.theme.colors.magic.buttonBase};
    color: #fff !important;
  }
  @media (max-width: 991px){
    background: ${(props) =>
      // no idea where this color came from or why it isn't in design system.
      props.active ? 'rgba(39,184,206,1)' : 'transparent'};
`;

const ImageFlexContainer = styled('div')`
  display: flex;
  gap: 50px;
`;

const SingleImageWrapper = styled('div')`
  flex: 1;
  @media (max-width: 991px) {
    display: none;
  }
`;

const MultiImageWrapper = styled('div')`
  flex: 2.7;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  column-gap: 20px;
  height: fit-content;
  row-gap: 20px;
  width: 100%;
  margin-top: 30px;
  @media (max-width: 991px) {
    gap: 7.5px;
    justify-content: center;
    padding: 0 20px;
    margin-top: 0;
  }
  img,
  picture {
    ${(props) => (props.isBuilder ? 'height: 100%;' : '')}
    ${(props) => (props.isBuilder ? 'width: 100%;' : '')}
  }
`;


const Image = styled(LazyImage)`
  height: 100%;
  width: 100%;
  object-fit: contain;
`;

const Picture = styled(m.div)`
  grid-area: ${(props) => `img${props.index}`};
  
  width: 100%;
  opacity: 0;
  height: 100%;

  @media ${(props) => props.theme.queries.desktopAndUp} {
    display: block;
    height: auto;
  }
`;

const MultiPicture = styled(m.div)`
  grid-area: ${(props) => `img${props.index}`};
  aspect-ratio: 1;
  width: calc(50% - 10px);
  opacity: 0;
  border-radius: 15px;
  overflow: hidden;
  height: 100%;
  @media ${(props) => props.theme.queries.desktopAndUp} {
    display: block;
  }
`;

const ButtonWrapper = styled('div')`
  grid-column: main-start / main-end;
  display: flex;
  justify-content: center;
`;

const SwipeText = styled('div')`
  display: none;
  @media(max-width: 991px){
    display: block;
    margin: 0 auto 20px auto;
    font-size: 14px;
    font-family: 'Space Grotesk'
  }
`

export {
  PillButtonWrapper,
  PillButton,
  Image,
  Picture,
  ButtonWrapper,
  ImageFlexContainer,
  SingleImageWrapper,
  MultiImageWrapper,
  MultiPicture,
  SwipeText
};
